import { cn } from "@/utils/cn";
import { memo } from "react";

// Double 4-point sparkle — matches the Figma "AI Icon Container v2" glyph.
const Sparkle = () => (
  <svg
    viewBox="0 0 19.3731 19.0001"
    fill="none"
    aria-hidden
    className="h-[18px] w-[18px]"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2615 10.6798C11.4994 8.89154 8.94119 4.47062 8.44446 2.48368C6.65622 8.24578 1.98693 10.183 0 10.6798C5.7621 12.468 7.94773 17.0131 8.44446 19.0001C10.2327 13.238 15.2745 11.1765 17.2615 10.6798Z"
      fill="currentColor"
    />
    <path
      d="M19.3731 2.95801C17.2175 2.31263 16.2605 0.717109 16.0746 2.1055e-05C15.4056 2.07958 13.6589 2.77874 12.9155 2.95801C15.0712 3.60339 15.8888 5.24373 16.0746 5.96082C16.7436 3.88126 18.6298 3.13728 19.3731 2.95801Z"
      fill="currentColor"
    />
  </svg>
);

interface SparkleButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  "aria-label": string;
  className?: string;
  /** Shows the purple "1" marker at the top-right (Figma 166:711). */
  badge?: boolean;
}

/**
 * The 44px sparkle button that sits on the right of My Plan v2 cards (Figma
 * "Chat Button LI"). Purely presentational — callers decide what a tap does.
 */
export const SparkleButton = memo(function SparkleButton({
  onClick,
  "aria-label": ariaLabel,
  className,
  badge = false,
}: SparkleButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className={cn("relative flex h-11 w-11 items-center justify-center", className)}
    >
      <span className="flex h-[38px] w-[38px] items-center justify-center rounded-full bg-[#F3F1F8] text-[#620AD5]">
        <Sparkle />
      </span>
      {badge && (
        <span
          data-testid="sparkle-badge"
          aria-hidden
          className="absolute top-0 left-[28px] flex h-[19px] w-[19px] items-center justify-center rounded-full bg-[var(--color-os-brand)] text-[11px] leading-none font-bold text-white"
        >
          1
        </span>
      )}
    </button>
  );
});
